import {
  acceptParentConnectRequestMockHandler,
  rejectParentConnectRequestMockHandler,
} from '@/features/parent-connect-respond';

// The respond page now reuses the parent-connect overview API
// (mocked under parent-connect-booking) instead of a dedicated
// single-session endpoint, so we only need the action mocks here.
export const parentConnectRespondHandlers = [
  acceptParentConnectRequestMockHandler,
  rejectParentConnectRequestMockHandler,
];
